var map = {
	"./Blast1.json": [
		628,
		95
	],
	"./Blast2.json": [
		629,
		96
	],
	"./Fireball.json": [
		630,
		97
	],
	"./Firework1.json": [
		631,
		98
	],
	"./Firework2.json": [
		632,
		99
	],
	"./Fireworkstart.json": [
		633,
		100
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1175;
module.exports = webpackAsyncContext;